import useTranslation from '@/utils/hooks/translation/useTranslation';

const ErrorDefaultFallback = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => {
    const { t } = useTranslation();
    return (
        <div
            role="alert"
            className="flex h-full w-full flex-1 flex-col items-center justify-center space-y-3 rounded p-8">
            <p className="text-center">{t('errors:error_occured_fetch_data')} </p>
            <button className="text-icoBlue underline" onClick={resetErrorBoundary}>
                {t('commons:try_again')}
            </button>
        </div>
    );
};

export default ErrorDefaultFallback;
